<script lang="ts">
    import DynamicEsi from '@shared/components/dynamic-esi/DynamicEsi.svelte';
    import type { SearchContext } from '@shared/types/types.ts';

    function buildOttoUpPromoEsiUrl(searchContext: SearchContext): string {
        return `/up-teaserui/productlist?dreson=${encodeURIComponent(searchContext.rule)}`;
    }

    interface Props {
        searchContext: SearchContext;
    }

    let { searchContext }: Props = $props();

    const src = $derived(buildOttoUpPromoEsiUrl(searchContext));
</script>

<div class="reptile-otto-up-promo">
    <DynamicEsi {src} name="OttoUpPromo" />
</div>

<style lang="scss">
    .reptile-otto-up-promo {
        width: 100%;
    }
</style>
